import projectData from "./projectsData";
import Project from "../../components/Project";
import PageHeader from "../../components/PageHeader";

const Portfolio = () => {
  const visibleProjects = projectData.filter((project) => !project.hidden);

  const ProjectList = () =>
    visibleProjects.map((project, i) => (
      <Project
        key={i}
        id={project.id}
        title={project.title}
        technologies={project.technologies}
        image={project.image}
        color={project.bgcolor}
        github={project.github}
        deployed={project.deployed}
        description={project.description}
      />
    ));

  return (
    <section className="portfolio">
      <PageHeader
        className="portfolio"
        title="Projects"
        style={{
          color: "red",
          fontSize: "2vh",
          marginBottom: "2vh",
        }}
      />
      <div className="row">
        <ProjectList />
      </div>
    </section>
  );
};

export default Portfolio;
